<template>
    <BaseModal
        :is-open="isOpen"
        @modal-close="closeModal"
        :is-loading="isStatusLoading"
        content-wrapper-class="contact-us-modal"
        identifier="contact-us"
        ><div id="promiseCaptchaContainer"></div
    ></BaseModal>
</template>

<script>
import ContactUsForm from '../../qaamgo/modules/sat/components/ContactUsForm';
import { eventBus } from '../../lib/event-bus/event-bus';
import { CONTACT_US_CLOSE_MODAL, CONTACT_US_OPEN_MODAL } from './event';
import BaseModal from '../user/modal/BaseModal';
import { contactUsModalRoute } from '../user/modal/contact_us/router';
import { testIsNonEmptyString } from '../../lib/test-and-assert/test-base';
import educationValidation from '../../qaamgo/modules/sat/components/education/EducationValidation.vue';

export default {
    name: 'ContactUsFormModal',
    components: { ContactUsForm, BaseModal },
    created() {
        eventBus.listen(CONTACT_US_OPEN_MODAL, (data) => {
            let event = '';
            let education = false;
            let defaultQuestionType = 'question';

            if (data?.education) {
                education = data?.education;
            }

            if (data?.defaultQuestionType) {
                defaultQuestionType = data.defaultQuestionType;
            }

            if (testIsNonEmptyString(data?.event)) {
                event = data.event;
            }

            if (this.$router.currentRoute.fullPath !== `/${contactUsModalRoute.CONTACT_US}/${event}`) {
                this.$router.push({
                    name: contactUsModalRoute.CONTACT_US,
                  params: {
                    defaultQuestionType: defaultQuestionType
                  },
                  query: {
                    event: event,
                    education: JSON.stringify(education)
                  },
                });
            }

            this.openModal();
        });

        eventBus.listen(CONTACT_US_CLOSE_MODAL, () => {
            this.closeModal();
        });
    },
    methods: {
        closeModal() {
            this.isOpen = false;
        },
        openModal() {
            this.isOpen = true;
        },
    },
    data() {
        return {
            isOpen: false,
            isStatusLoading: false,
        };
    },
};
</script>

<style lang="scss">
// this is needed to avoid having a visible seam during the modal slide animation
.contactus-modal-background::before {
    display: block;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 10000;
    background: rgba(0, 0, 0, 0.42);
    content: '';
    left: -100%;
}

.contact-us-modal .contact-us-form-container {
    width: 100%;
    max-width: 480px;
}
</style>
